import { API } from "../axios/API";

const getAllRegisters = async (queryParams) => {
  try {
    const resp = await API.get(`/loginInfo/resumeregisters?${queryParams}`);
    return resp.data;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

const getRegistersByDni = async (userDni) => {
  try {
    const resp = await API.get(`/loginInfo/registers?userDni=${userDni}`);
    return resp.data;
  } catch (err) {
    console.error("Error al obtener la información:", err);
    return err.response;
  }
};

export const LoginRegistersService = {
  getAllRegisters,
  getRegistersByDni,
};
